export default __webpack_public_path__ + "static/logo-univr-a1cd39cb90f1b860186747bb556ad4b7.png";